
 <div class="pageContent">
  <div class="pageTitle">
    <h2>Auditoria Procesos</h2>
  </div>
  <button type="button" (click)="descargarReporteGeneral()" class="ms-Button">Descargar Reporte General</button>
  <app-data-table tableId="datatableAuditoria" [serverSide]="true" [serverData]="getDataTableAuditoria" [columns]="columnas" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtons"></app-data-table>
  <div class="pageTitle">
    <h2 id="processId"></h2>
  </div>
  <table datatable [dtOptions]="dtOptionsDetalleEjecucionProceso" [dtTrigger]="dtTrigger" class="ms-Table ms-Table--selectable order-column row-border" style="width: 100%" id="datatableDetalleEjecucionProcesos"></table>
</div>
 


<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader cancel-observation">
    <div id="dialogCreateEdit" class="ms-Dialog-title">Cancelar ejecución proceso</div>
    <form [formGroup]="cancelProcessForm" (ngSubmit)="enviarAccionProceso()" name="cancelProcessForm">
      <div class="ms-Dialog-content">
        <app-text-area [frm]="cancelProcessForm" formControlName="Observacion" [readonly]="viewObs" [required]="true" label="Observaciones" rows="3"></app-text-area>
      </div>
      <div *ngIf="viewObs" style="margin-top: 24px;">
        <app-button buttonClass="ms-Button ms-Dialog-action" buttonId="btnClose" (buttonClick)="closeCancelModal()" label="Aceptar"></app-button>
      </div>
      <div *ngIf="!viewObs">
        <app-form-buttons 
        [botonProcesando]="botonProcesando"
        buttonCancelId="btnCancel"
        labelCancel="Cancelar"
        buttonSaveId="btnCreateEdit"
        labelSave="Guardar"
        labelLoading="Cargando" 
        [frm]="cancelProcessForm"
        (cancel)="clearCancelForm()">
        </app-form-buttons>
      </div>
    </form>
  </div>
</div>

<div class="docs-DialogExample-lgHeader success">
  <div class="ms-Dialog ms-Dialog--lgHeader enviar-accion">
    <div class="ms-Dialog-title">Retomar ejecución proceso</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">¿Desea retomar la ejecución del proceso?</p>
    </div>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>
      <button
        (click)="enviarAccionProceso()"
        class="ms-Button ms-Dialog-action ms-Button--primary"
      >
        <span class="ms-Button-label">Guardar</span>
      </button>
    </div>
  </div>
</div>

<app-modal-notify #crearModal></app-modal-notify> 

<app-generic-modal
  [isVisible]="modalDiagramaVisible"
  [title]="'Proceso '+ idEjecucionProcesoTitle + ' - '+ NombreProcesoTitle"
  [showLoading]="!mostrarDiagrama"
  loadingMessage="Cargando diagrama..."
  showActionButton="true"
  actionButtonIcon="ms-Icon--Refresh"
  (actionButtonClick)="customClick('btnVerDiagramaProceso', true)"
  (closeModal)="cerrarModalDiagrama()">
  <app-diagram-viewer 
    *ngIf="mostrarDiagrama"
    [xmlContent]="xmlContent"
    [readOnly]="true"
    [tooltipProperties]="tooltipProperties"
    [showLegend]="true"
    [legendTitle]="'Estados del Proceso'"
    [legendItems]="legendaColores">
  </app-diagram-viewer>
</app-generic-modal>

<!-- Modal para Dashboard del Proceso -->
<app-generic-modal
  [isVisible]="modalDashboardVisible"
  [title]="'Dashboard del Proceso '+ idEjecucionProcesoTitle + ' - '+ NombreProcesoTitle"
  [showLoading]="!mostrarDashboard"
  loadingMessage="Cargando dashboard..."
  (closeModal)="cerrarModalDashboard()">
  <app-process-dashboard 
    *ngIf="mostrarDashboard"
    [processMetrics]="processDashboardData">
  </app-process-dashboard>
</app-generic-modal>